import { render, staticRenderFns } from "./new-role-modal.vue?vue&type=template&id=3844dd5f&"
import script from "./new-role-modal.vue?vue&type=script&lang=js&"
export * from "./new-role-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports